
import React , { useState , useEffect  }  from "react";
import { useSelector  } from "react-redux";

import {useUser,  useYousign , useContrats} from "../../state/reactquery";
import { queryClient } from '../../state/queryClient';

import { useSignassur } from "../../state/reactquery";
import { axios_ficbulletin_fictosignassur } from "../../axios/axios_ficbulletin";

// import { axios_yousign_renvoiliensignature } from "../../axios/axios_yousign";
import { axios_ficbulletin_fictoyousign , axios_ficbulletin_ficupload } from "../../axios/axios_ficbulletin";
 
import { modifyoneleadfrontback  } from "../../utils/actions_lead";
import { formatdate } from "../../utils/utils_dates";

import Button from "../Buttons/Button";
import Besoins from "../../Ecrans/EcranFicheClient/Besoins";
import Boulettes from "./Boulettes";



import './ContratWinFic.scss' ;
function ContratWinFicSend(){
        const lead = useSelector(state=>state.lead.leadactu) ;
        const [etape, setEtape] = useState(0) ;
        const {data: yousign} = useYousign(lead?.id_fic) ; 
        const {data: signasuur} = useSignassur(lead?.id_fic) ; 
        const {data: user} = useUser(localStorage.getItem('token'))  ;

        const lasignature = user?.email==='monsieursellam@gmail.comX'?signasuur:yousign ;
        
        const {data: contrats} = useContrats(lead?.email,lead?.courtier) ; 
        const formule = contrats?.filter(c=>c.id_contrat===lead.id_contrat)?.[0] ;

        const [horaire, setHoraire]  = useState(null) ; 
        const [loading, setLoading]  = useState(false) ; 
        const [loadingupload, setLoadingupload]  = useState(false) ; 
        

        const etat_signfic_nobulletin_no  =   lead?.['sign_fic']===0;
        const etat_signfic_nobulletin_wait = lead?.['sign_fic']===1 && !lasignature?.signature_link   ;
        const etat_signfic_nobulletin_send =  lead?.['sign_fic']===1 && lasignature?.signature_link  ;
        const etat_signfic_nobulletin_done =  lead?.['sign_fic']===2  ;

        useEffect(()=>{const newetape = loading===1 ? 1:lead?.['sign_fic']===0? 0: lead?.['sign_fic']===1? 2: lead?.['sign_fic']===2? 3: 0
                        setEtape(newetape)
         },[lead?.['sign_fic'], loading])

        useEffect(()=>{ (lasignature?.status==='ongoing' || lasignature?.status==='sent' || lasignature?.status==='creation' )&& setHoraire(formatdate(lasignature?.date_initialisation)) ;
                        (lasignature?.status==='done'  || lasignature?.status==='finished'  ) && setHoraire(formatdate(lasignature?.date_signature)) ;
                        const newetape =etat_signfic_nobulletin_no?0:
                                                etat_signfic_nobulletin_wait ? 1:
                                                etat_signfic_nobulletin_send ? 2:
                                                etat_signfic_nobulletin_done ? 3: 0 ;
                        console.log("NE",newetape,lead?.['sign_fic'],lasignature,lasignature?.signature_link) ; 
                       // setEtape(newetape)
        },[lasignature?.id])

        const textbottom = etape==0?"Signez avec ":etape==3?`Signé le ${horaire} avec `:`Envoyé le ${horaire} avec ` ;
        const textbutton = loading?'Envoi en cours':etape===0?"Envoi pour signature":etape===1?"Envoi en cours":etape===2?"Copier le lien de signature":"Signé" ;
        const colorbutton = etape===2?'bouton_backcolor_orangelight':'bouton_color_orange' ;
        const disablebutton = etape===1 || loading  || etape===3; 

        const sendconseil= async () =>{  
                if(etape===0){
                        if(user.email==='monsieursellam@gmail.comX'){await sendfictosignassur() ;
                        }else{ await sendfictoyousign() ;     
                                setTimeout(()=>{queryClient.invalidateQueries({ queryKey: ['yousign',lead.id_fic]}) ;},1000*60*3) ;
                        }
     
                }
                if(etape===2){navigator.clipboard.writeText(lasignature?.signature_link);}
        }




       // DEV SIGNASSUR
        const sendfictoyousign= async () =>{
                setLoading(true) ;
                const req = await axios_ficbulletin_fictoyousign({lead,formule}) ; 
         
                setTimeout(()=>{setLoading(false) ;
                                modifyoneleadfrontback({...lead,'id_fic':req.data,'sign_fic':1,'statut_client':'attente_signature'}) ;   
                                queryClient.invalidateQueries({ queryKey: ['histories',lead.id]});
                                queryClient.invalidateQueries({ queryKey: ['documents',lead.id]});
                                setHoraire(new Date().toLocaleString('fr-FR')); },1000); 
       }
       
        const sendfictosignassur= async () =>{
                setLoading(true) ;
                const req = await axios_ficbulletin_fictosignassur({lead,formule}) ; 
         
                setTimeout(()=>{setLoading(false) ;
                                 modifyoneleadfrontback({...lead,'id_fic':req.data,'sign_fic':1,'statut_client':'attente_signature'}) ;   
                                queryClient.invalidateQueries({ queryKey: ['histories',lead.id]});
                                queryClient.invalidateQueries({ queryKey: ['documents',lead.id]});
                                queryClient.invalidateQueries({ queryKey: ['signassur',req.data]}) ; 
                                setHoraire(new Date().toLocaleString('fr-FR')); },1000); 
       }

       const uploaddocument = async () =>{
        setLoadingupload(true) ;
        const response = await axios_ficbulletin_ficupload({lead, formule});
        const pdfData= new Blob([response.data], {type:'application/pdf'}) ; 
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(pdfData);
        a.setAttribute("download", `ficbulletin_ns${(new Date()).getTime()}.pdf`);
        a.setAttribute('target', '_blank');
        a.click();
        a.remove();
        setTimeout(() => window.URL.revokeObjectURL(a.href), 100) ;
        setLoadingupload(false) ;
    }


        return(<div className='contratwin_box'>
                        <div className='contratwin_box_top'>
                                <div className='contratfic_box_top_texte'>Besoins exprimés par le client</div>
                                <Besoins />
                                <div className="ht10" ></div>
                                <div className='contratfic_flex'> 
                                <div className='contratfic_flex_middle2'>
                                         <div className='bulletin_listedoc'>Fiche Information & Conseil : </div>
                                        <div className="contratwinfic_lineformule fontbold"> 
                                          <span  >{formule?.compagnie}</span> <span  >-</span>
                                          <span >{formule?.gamme}</span> <span  >-</span>
                                          <span  >{formule?.formule}</span> <span  >-</span>
                                          <span  >{formule?.prix}  € </span> 
                                        </div>
                                </div>
                                </div>
                        </div>
                        <div className='contratwin_box_bottom'>
                                <div className='contratwin_box_bottom_left'>
                                        <Boulettes total={3} etape={etape} />
                                        <div className='contratwin_box_bottom_message'>{textbottom}</div>
                                </div>
                                <div>
                                        {(etape===0 && !loading ) && <Button texte='Télécharger'
                                                        color='bouton_color_orange'
                                                        disable={false}
                                                        loading={loadingupload}
                                                        size='bouton_size_normal'
                                                        onclick={uploaddocument} />}
                                        <div className="separatebuttons"></div>
                                        <Button texte={textbutton}
                                                color={colorbutton}
                                                disable={disablebutton}
                                                loading={loading}
                                                size='bouton_size_normal'
                                                onclick={sendconseil} />
                                </div>
                        </div>
                </div>);
}

export default ContratWinFicSend ;

